module.exports = __webpack_public_path__ + "static/Stq-ab74e6ecbec48b2c5fbb8ebf6e8dd6c9.png";